import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { SearchInputAreaBox } from "./boxes/search-input-area-box/search-input-area.box";
import { CyClass } from '../../../../../common/cy-classes';
import { ComponentServicesPick } from "../../../../services/component-services-pick";
import { useServices } from "../../../../react-hooks/use-services.hook";
import { withServices } from "../../../../react-hooks/with-services";

interface SearchInputAreaProps extends ComponentServicesPick<'gameSearch'> {

}

const ComponentBody: React.FC<SearchInputAreaProps> = observer((props) => {
  const services = useServices();
  const _timeoutRef = useRef<any>(null);
  const HIDE_KEYBOARD_DELAY_MS = 2000;

  useEffect(() => {
    return () => {
      if (_timeoutRef.current) {
        clearTimeout(_timeoutRef.current)
      }
    }
  }, []);

  const _onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.gameSearch.search(event.target.value);
  }

  const _onChangeHandlerWithBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.gameSearch.search(event.target.value);

    if (_timeoutRef.current) {
      clearTimeout(_timeoutRef.current);
    }

    _timeoutRef.current = setTimeout(() => {
      _timeoutRef.current = null;
      if (props.gameSearch.currentSearchText) {
        props.gameSearch.searchInputRef.current?.blur();
      }
    }, HIDE_KEYBOARD_DELAY_MS);
  };

  const _onClickHandler = async () => {
    await props.gameSearch.openSearchResult();
  };

  const onChangeHandler = services.device.isMobile ? _onChangeHandlerWithBlur : _onChangeHandler;

  return (
    <SearchInputAreaBox
      ref={props.gameSearch.searchInputRef}
      className={CyClass('cy-game-search-input')}
      type={'text'}
      value={props.gameSearch.currentSearchText}
      autoComplete={'off'}
      placeholder={services.translation.translate('SEARCH_YOUR_GAME')}
      onChange={onChangeHandler}
      onClick={_onClickHandler} />
  );
})

export const SearchInputArea = withServices(ComponentBody, ['gameSearch']);